"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopoverInput = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var clsx_1 = tslib_1.__importDefault(require("clsx"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var Popover_1 = tslib_1.__importDefault(require("@material-ui/core/Popover"));
var Grid_1 = tslib_1.__importDefault(require("@material-ui/core/Grid"));
var fp_1 = require("lodash/fp");
exports.PopoverInput = react_1.forwardRef(function (_a, ref) {
    var format = _a.format, value = _a.value, className = _a.className, children = _a.children, _b = _a.inputProps, inputProps = _b === void 0 ? {} : _b, _c = _a.popoverProps, popoverProps = _c === void 0 ? {} : _c, _d = _a.popoverContentStyle, popoverContentStyle = _d === void 0 ? {} : _d, _e = _a.onPopoverChange, onPopoverChange = _e === void 0 ? fp_1.noop : _e;
    var placeholder = inputProps.placeholder, endAdornment = inputProps.endAdornment, disabled = inputProps.disabled;
    var _f = react_1.useState(null), anchorEl = _f[0], setAnchorEl = _f[1];
    var _g = react_1.useState(0), width = _g[0], setWidth = _g[1];
    var divRef = react_1.useRef(null);
    var input = divRef.current;
    react_1.useEffect(function () {
        if (!input) {
            return;
        }
        var w = input.getBoundingClientRect().width;
        setWidth(w);
    }, [input]);
    react_1.useImperativeHandle(ref, function () { return ({
        close: handleClose,
    }); });
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
        onPopoverChange(true);
    };
    var handleClose = function () {
        setAnchorEl(null);
        onPopoverChange(false);
    };
    var isOpen = Boolean(anchorEl);
    return (react_1.default.createElement(StyledContainer, { ref: divRef, className: clsx_1.default(className, { opened: isOpen, disabled: disabled }) },
        react_1.default.createElement(InputBox, tslib_1.__assign({ className: "popover-input", onClick: handleClick, role: "textbox" }, inputProps),
            fp_1.isEmpty(format(value)) ? (react_1.default.createElement(PlaceholderWrapper, null, placeholder)) : (react_1.default.createElement(ValueWrapper, null, format(value))),
            endAdornment && react_1.default.createElement(EndWrapper, null, endAdornment)),
        react_1.default.createElement(StyledPopover, tslib_1.__assign({ open: isOpen, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
            } }, popoverProps),
            react_1.default.createElement(StyledPopoverContent, { style: tslib_1.__assign({ minWidth: width }, popoverContentStyle) },
                react_1.default.createElement(Grid_1.default, { container: true, alignItems: "center", direction: "column", className: "popover-content-grid" }, children)))));
});
exports.PopoverInput.displayName = 'FOS_PopoverInput';
var InputBox = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  font-size: 1.3rem;\n  line-height: 28px;\n  border: 1px solid ", ";\n"], ["\n  display: flex;\n  flex-direction: row;\n  font-size: 1.3rem;\n  line-height: 28px;\n  border: 1px solid ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[200];
});
var ValueWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  padding: 2px 8px;\n  min-height: 32px;\n  flex: 1;\n"], ["\n  padding: 2px 8px;\n  min-height: 32px;\n  flex: 1;\n"])));
var PlaceholderWrapper = styled_components_1.default(ValueWrapper)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  opacity: 0.4;\n"], ["\n  opacity: 0.4;\n"])));
var EndWrapper = styled_components_1.default.div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  height: 32px;\n"], ["\n  display: flex;\n  align-items: center;\n  height: 32px;\n"])));
var StyledPopover = styled_components_1.default(Popover_1.default)(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  border-radius: 0;\n"], ["\n  border-radius: 0;\n"])));
var StyledPopoverContent = styled_components_1.default.div(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  padding: 3.2rem;\n"], ["\n  padding: 3.2rem;\n"])));
var StyledContainer = styled_components_1.default.div(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n  &&.opened {\n    box-shadow: ", ";\n    border: ", ";\n  }\n  &&.disabled {\n    opacity: 0.4;\n  }\n"], ["\n  &&.opened {\n    box-shadow: ",
    ";\n    border: ",
    ";\n  }\n  &&.disabled {\n    opacity: 0.4;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return "0 0 0.5rem 0.1rem " + theme.colors.green[500] + " !important";
}, function (_a) {
    var theme = _a.theme;
    return "thin solid " + theme.colors.NTDarkGrey[200] + " !important";
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
